<template>
  <div class="promoter-balance">
    <div class="balance-row">
      <div class="card-item">
        <div class="card-count" v-if="isHideInfo">***</div>
        <div class="card-count" v-else>{{ formatPrice(balance.total_actual_profit) }}</div>
        <div class="card-desc">总佣金({{ currencyName }})</div>
      </div>
      <div class="card-item">
        <div class="card-count" v-if="isHideInfo">***</div>
        <div class="card-count" v-else>{{ formatPrice(balance.total_done_payout) }}</div>
        <div class="card-desc">已提现({{ currencyName }})</div>
      </div>
      <div class="card-item">
        <div class="card-count" v-if="isHideInfo">***</div>
        <div class="card-count" v-else>{{ totalPendingProfitText }}</div>
        <div class="card-desc">待提现({{ currencyName }})</div>
      </div>
    </div>
    <div class="balance-row">
      <div class="card-item">
        <div class="card-count">{{ formatCount(balance.total_actual_order) }}</div>
        <div class="card-desc">有效订单数</div>
      </div>
      <div class="card-item">
        <div class="card-count">{{ formatCount(promoter.total_customer) }}</div>
        <div class="card-desc">推广用户数</div>
      </div>
      <div class="card-item">
        <div class="card-count">{{ formatCount(promoter.customer_count_final) }}</div>
        <div class="card-desc">绑定用户数</div>
      </div>
    </div>
    <div class="balance-row" v-if="isMerchant">
      <div class="card-item">
        <div class="card-count">{{ formatCount(balance.total_revoke_order) }}</div>
        <div class="card-desc">退款订单数</div>
      </div>
      <div class="card-item">
        <div class="card-count">{{ formatCount(promoter.customer_count_first) }}</div>
        <div class="card-desc">拉新用户数</div>
      </div>
      <div class="card-item">
        <div class="card-count">{{ formatCount(promoter.customer_count_latest) }}</div>
        <div class="card-desc">抢客用户数</div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, formatPrice } from '@/plugins/price'
import _ from 'lodash'

export default {
  props: {
    balance: {
      type: Object,
      required: true,
    },
    promoter: {
      type: Object,
      required: true,
    },
    isMerchant: {
      type: Boolean,
      default: false,
    },
    isHideInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currency() {
      return this.balance.currency
    },
    currencyName() {
      return formatCurrency(this.currency)
    },
    totalPendingProfitText() {
      let total_should_payout = this.balance.total_should_payout
      let total_created_payout = this.balance.total_created_payout
      if (_.isNil(total_should_payout) && _.isNil(total_created_payout)) {
        return '-'
      }
      let value = (total_should_payout || 0) + (total_created_payout || 0)
      return formatPrice(value, this.currency)
    },
  },
  methods: {
    formatPrice(value) {
      if (_.isNil(value)) {
        return '-'
      }
      return formatPrice(value, this.currency)
    },
    formatCount(value) {
      if (_.isNil(value)) {
        return '-'
      }
      return value
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.promoter-balance {
  .balance-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  }

  .card-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 96px;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .card-desc {
    color: @antTextGrey;
  }

  .card-count {
    font-size: 20px;
    min-height: 28px;
    font-family: monospace;
  }
}
</style>
